import React from "react";

import PaperDarkBG from "../kits/DesignKit/PaperDarkBG";


/**
 * SectionHeader - Wiederverwendbare Section-Header Komponente mit Badge, Headline und Subtext
 *
 * @param {string} badge - Badge Text (z.B. "Referenzen", "Überblick")
 * @param {string} headline - Hauptüberschrift (optional)
 * @param {string} subtext - Untertitel/Beschreibung (optional)
 * @param {string} className - Zusätzliche CSS-Klassen
 * 
 */
const SectionHeader = ({
  badge,
  headline,
  subtext,
  className = "",
  fullWidth = true
}) => {
  const content = (
    <div className={`text-center space-y-4 ${className}`}>
      {/* Badge */}
      <div className="flex justify-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#AC8E66] bg-[#AC8E66]/10 px-4 py-1.5 text-xs  text-[#ffffff] font-mono">
          <span className="h-2 w-2 rounded-full bg-brand" />
          {badge}
        </div>
      </div>

      {/* Headline (optional) */}
      {headline && (
        <h2 className="text-lg sm:text-2xl font-bold text-brand">
          {headline}
        </h2>
      )}

      {/* Subtext (optional) */}
      {subtext && (
        <p className="text-xs sm:text-sm text-gray-200 max-w-2xl mx-auto">
          {subtext}
        </p>
      )}
    </div>
  );

  if (!fullWidth) {
    return <PaperDarkBG>{content}</PaperDarkBG>;
  }

  return (
    <PaperDarkBG className="w-screen relative left-1/2 -translate-x-1/2">
      <div className="max-w-4xl mx-auto px-4 py-6">
        {content}
      </div>
    </PaperDarkBG>
  );
};

export default SectionHeader;
